import TermCreateEdit from "../AdminTermCreateEdit";

export default class AdminTermCreateEditNoteType extends TermCreateEdit {
    /**
     * @returns {string} The term type.
     */
    getType() {
        return 'note_type';
    }
}
